
<main>
    <div class="city-search">
        <div class="filtering">
            <form>
                <input type="search" class="form-control" placeholder="શોધો.." #filter
                    (keyup)="searchCity($event)"/>
                <i class="ti ti-search"></i> 
            </form>
            <i class="ti ti-filter cursorClass" (click)="openBottomSheet()"></i>
            <i class="ti ti-refresh cursorClass" (click)="getCity()"></i>
            <a routerLink="/city/add-city/0"><i class="ti ti-plus cursor:pointer"></i></a>
        </div>
    </div>
    <div class="city-list">
        <div class="main-members">
            <a *ngFor="let data of cityList" class="member-list-item">
                <div class="flex1">
                    <h5>{{data.city_name}}</h5>
                    <p>{{data.country_name}}</p>
                </div>
                <i class="ti ti-pencil" [routerLink]="['/city/add-city/',data.city_id]"></i>
                <mat-slide-toggle [(ngModel)]="data.is_active" class="example-margin"  *ngIf="userTypeId == 1"
                [color]="data.is_active == 1? 'green' : 'red' " (change)="openDialog($event,data)">
              </mat-slide-toggle>
                <!-- <i class="ti ti-trash" (click)="deleteCity(data.city_id)"></i> -->
            </a>
        </div>
    </div>
</main>